<template>
	<v-app-bar app class="ui-toolbar">
		<v-spacer />
		<avatar-menu v-if="user" :user="user" />
	</v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";
import AvatarMenu from "~/components/core/AvatarMenu.vue";

export default {
	components: { AvatarMenu },
	computed: {
		...mapGetters(["loggedInUser"]),
		user() {
			return this.loggedInUser;
		},
	},
};
</script>

<style scoped>
.ui-toolbar {
	background-color: var(--ui-bg-surface, #fff) !important;
	border-bottom: 1px solid var(--ui-border, #eef0f3) !important;
}
</style>
